// Module
var code = "<div> <label>Severity</label> <select ng-model=\"severity\" ng-options=\"k as v for (k,v) in severities\" ng-change=\"selected()\" class=\"form-control\"></select> </div> ";
// Exports
module.exports = code;